import { useStaticQuery, graphql } from 'gatsby'

export const useHomeHeroQuery = () => {
  const { wpPage, wp } = useStaticQuery(graphql`
    query HomeHeroQuery {
      wpPage(title: { eq: "Home" }) {
        homeHero {
          homeHero {
            backgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            backgroundVideo
            overlayImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            overlayImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            title {
              titleWhite1
              titleOrange
              titleWhite2
            }
            text
            playButtonText
          }
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            heroBadge {
              localFile {
                publicURL
              }
            }
            button2Text
            playButton {
              playButton {
                localFile {
                  publicURL
                }
              }
              videoLink {
                title
                url
              }
            }
          }
        }
      }
    }
  `)
  return { wpPage, wp }
}
